<template>
  <div class="con">
	
	<template v-if="list && list.length > 0 && params.nav==0">
		<van-sticky>
			<van-row class="row">
				<van-col span="8" style="text-align: center;">项目名称</van-col>
				<van-col span="4" style="text-align: center;" >结果</van-col>
				<van-col span="2" style="text-align: center;" >提示</van-col>
				<van-col span="4" style="text-align: center;" >单位</van-col>
				<van-col span="6" style="text-align: center;" >参考值</van-col>
			</van-row>
		</van-sticky>
		<van-row v-for="(item,index) in list" :key="'l'+index" class="row" :style="{color:item.HINT?'red':''}">
			<van-col span="8">{{item.CHINESENAME}}</van-col>
			<van-col span="4" style="text-align: center;" >{{ item.TESTRESULT }}</van-col>
			<van-col span="2" style="text-align: center;">{{ item.HINT }}</van-col>
			<van-col span="4" style="text-align: center;">{{ item.UNIT}}</van-col>
			<van-col span="6" style="text-align: center;">{{item.REFLO}}-{{ item.REFHI }}</van-col>
		</van-row>
	</template>


	<template v-if="list && list.length > 0 && params.nav==1 && examInfo">
		<div class="list">
			<div class="list-con">
				<label>检查项目</label>
				<div>{{examInfo.examineparts}}</div>
			</div>
			<div class="list-con">
				<label>报告医生</label>
				<div>{{examInfo.reportdoctorname}}</div>
			</div>
			<div class="list-con">
				<label>报告时间</label>
				<div>{{formatDateTime(examInfo.reportdate)}}</div>
			</div>
			<div class="list-con2">
				<label>描述</label>
				<div class="context">{{examInfo.examinationsee}}</div>
			</div>
			<div class="list-con2">
				<label>结论</label>
				<div class="context">{{examInfo.examinationresult}}</div>
			</div>
		</div>
		
	</template>


    <!-- <div class="list" v-for="item in list" v-if="navList.nav == 0">
			<div class="list-con">
				<label>检验名称：</label>
				<div>{{item.itemName}}</div>
			</div>
			<div class="list-con">
				<label>检验类别：</label>
				<div>{{item.inspectType}}</div>
			</div>
			<div class="list-con">
				<label>参考值范围 ：</label>
				<div>{{item.referenceRange}}</div>
			</div>
			<div class="list-con">
				<label>参考值上限：</label>
				<div>{{item.referenceHeighValue}}</div>
			</div>
			<div class="list-con">
				<label>参考值下限：</label>
				<div>{{item.referenceLowValue}}</div>
			</div>
			<div class="list-con">
				<label>检验结果：</label>
				<div>{{item.resultPromt}}</div>
			</div>
			<div class="list-con">
				<label>报告备注：</label>
				<div>{{item.meminfo}}</div>
			</div>
			<div class="list-con">
				<label>报告结果：</label>
				<div>{{item.reportResult}}</div>
			</div>
			<div class="list-con">
				<label>报告定量结果：</label>
				<div>{{item.quantitativeResult}}</div>
			</div>
			<div class="list-con">
				<label>报告定性结果：</label>
				<div>{{item.qualitativeResult}}</div>
			</div>
			<div class="list-con">
				<label>检验方法名称：</label>
				<div>{{item.inspectMethod}}</div>
			</div>
			<div class="list-con">
				<label>检验计量单位 ：</label>
				<div>{{item.unit}}</div>
			</div>
		</div>
		<div class="list" v-for="item in list" v-if="navList.nav == 1">
			<div class="list-con">
				<label>报告流水号：</label>
				<div>{{item.reportId}}</div>
			</div>
			<div class="list-con">
				<label>检查部位：</label>
				<div>{{item.studyPart}}</div>
			</div>
			<div class="list-con">
				<label>检查方法：</label>
				<div>{{item.studyMethod}}</div>
			</div>
			<div class="list-con">
				<label>检查日期：</label>
				<div>{{item.studyTime}}</div>
			</div>
			<div class="list-con">
				<label>审核医师：</label>
				<div>{{item.expert}}</div>
			</div>
			<div class="list-con">
				<label>报告医生：</label>
				<div>{{item.reportDoctor}}</div>
			</div>
			<div class="list-con">
				<label>报告日期：</label>
				<div>{{item.reportTime}}</div>
			</div>
			
			<div class="list-con">
				<label>判断结果：</label>
				<div>{{item.report}}</div>
			</div>
			<div class="list-con">
				<label>诊断结果：</label>
				<div>{{item.conclusion}}</div>
			</div>
		</div> -->
  </div>
</template>

<script>
export default {
  name: "reportDeta",
  data() {
    return {
      msg: "报告详情",
      list: [],
	  examInfo:undefined,
      cardUserInfo: JSON.parse(localStorage.getItem("cardUserInfo")),
      noImgShow: false,
      params: {}, //接收的参数
    };
  },
  methods: {
    loadData() {
      let url = "";
      if (this.params.nav == 0) {
        url =
          "/inpatient/queryLabDetail?brid=" +
          this.params.brid +
          "&mzzy=" +
          this.params.mzzy +
          "&sampleno=" +
          this.params.id;
      } else {
        url =
          "/inpatient/queryExamDetail?brid=" +
          this.params.brid +
          "&mzzy=" +
          this.params.mzzy +
          "&examid=" +
          this.params.id;
      }
      this.$store.commit("Load", true);
      this.$Axios
        .Get(url, null)
        .then((res) => {
          this.list = [];
		  this.examInfo = undefined
          this.$store.commit("Load", false);
          if (res.code == 0) {
            this.list = res.msg;
			if(this.list.length >0 && this.params.nav == 1){
				this.examInfo = this.list[0];
			}
            this.noImgShow = false;
            console.log(this.list);
          } else {
            this.noImgShow = true;
          }
        })
        .catch((err) => {
          this.$store.commit("Load", false);
          this.noImgShow = true;
          console.log(err);
        });
    },
	formatDateTime(date) {
      const date1 = new Date(date);
      return `${date1.getFullYear()}-${
        date1.getMonth() + 1 < 10
          ? "0" + (date1.getMonth() + 1)
          : date1.getMonth() + 1
      }-${date1.getDate()} ${date1.getHours()}:${date1.getMinutes()}`;
    },
  },
  mounted() {
    this.params = this.$route.query;
    console.log(this.params);
    this.loadData()
  },
  created() {},
};
</script>

<style scoped>
.con{
	font-size: 14px;
}
.row {
  padding: 10px 5px;
  font-size: 14px;
  background: #fff;
  border-bottom: 1px solid #ccc;
}
.list-con {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 10px;
		background-color: #fff;
		border-bottom: 1px solid #ccc;
		color: #999;
		font-size: 15px;
	}

.list-con label{
	width: 100px;
		color: #000;
		
	}

	.list-con2 {
		display: flex;
		align-items: flex-start;
		justify-content: left;
		flex-direction: column;
		padding: 20px 10px;
		background-color: #fff;
		border-bottom: 1px solid #ccc;
		color: #999;
		font-size: 15px;
	}

	.list-con2 label{
		font-weight: 700;
		font-size: 18px;
		color: #000;
		
	}

	.list-con2 .context{
		margin: 10px;
		line-height: 28px;
		color: #000;
	}
</style>
